var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 34.375V38.75",
    stroke: "#EC008C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8955 45.8333H35.7288V43.7499C35.7288 41.4583 33.8538 39.5833 31.5622 39.5833H19.0622C16.7705 39.5833 14.8955 41.4583 14.8955 43.7499V45.8333V45.8333Z",
    stroke: "#EC008C",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 45.8333H37.8125",
    stroke: "#EC008C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0003 33.3334C16.9378 33.3334 10.417 26.8126 10.417 18.7501V12.5001C10.417 7.89591 14.1462 4.16675 18.7503 4.16675H31.2503C35.8545 4.16675 39.5837 7.89591 39.5837 12.5001V18.7501C39.5837 26.8126 33.0628 33.3334 25.0003 33.3334Z",
    stroke: "#EC008C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3958 24.2708C9.83333 23.7708 8.45833 22.8542 7.375 21.7708C5.5 19.6875 4.25 17.1875 4.25 14.2708C4.25 11.3542 6.54167 9.0625 9.45833 9.0625H10.8125C10.3958 10.0208 10.1875 11.0833 10.1875 12.1875V18.4375C10.1875 20.5208 10.625 22.4792 11.3958 24.2708Z",
    stroke: "#EC008C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6045 24.2708C40.167 23.7708 41.542 22.8542 42.6253 21.7708C44.5003 19.6875 45.7503 17.1875 45.7503 14.2708C45.7503 11.3542 43.4587 9.0625 40.542 9.0625H39.1878C39.6045 10.0208 39.8128 11.0833 39.8128 12.1875V18.4375C39.8128 20.5208 39.3753 22.4792 38.6045 24.2708Z",
    stroke: "#EC008C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.6b33797a88c22f65638bb96f511b8df3.svg";
export { ForwardRef as ReactComponent };